<div class="form-group mb-0">
  <input
    #propertyName="ngModel"
    id="date-input-{{ name }}"
    class="form-control"
    type="text"
    [name]="name"
    [(ngModel)]="inputString"
    [disabled]="isDisabled"
    placeholder="Enter a date..."
    autocomplete="off"
    (ngModelChange)="onInputChange($event)"
    mask="M0/d0/0000"
    [outputTransformFn]="dateParser"
  />
  <div validationErrors [for]="propertyName.control" [errorEmitter]="errorEmitter"></div>
  <div class="form-text text-dark">Expected format is mm/dd/yyyy</div>
</div>
